<div class="sidenav-content">
  <mat-toolbar color="primary">
    @if (isMobile) {
      <mat-toolbar-row class="toolbar-menu">
        @if (!isGuest) {
          @if (showSiteSwitcher()) {
            <fss-portal-site-switcher-menu></fss-portal-site-switcher-menu>
          }
          @if (showSiteNotifications) {
            <fss-portal-notification></fss-portal-notification>
          }
          <fss-portal-user-profile></fss-portal-user-profile>
        } @else {
          <div>
            <button
              id="toolbar-guest-login-btn"
              mat-icon-button
              aria-label="Login"
              type="button"
              (click)="login()"
              >
              <mat-icon [svgIcon]="icons.LOGIN" title="Login"></mat-icon>
            </button>
          </div>
        }
      </mat-toolbar-row>
    }

    @if (getIsDestinyViewSelectorEnabled()) {
      <mat-toolbar-row>
        <fss-portal-view-type-select></fss-portal-view-type-select>
      </mat-toolbar-row>
    }
  </mat-toolbar>
  <mat-action-list>
    <mat-accordion>
      @for (menu of menuItems; track menu.id) {
        <ng-container *ngTemplateOutlet="menuTemplate; context: {$implicit: menu}"></ng-container>
      }
    </mat-accordion>
  </mat-action-list>
</div>

<ng-template #menuTemplate let-menu>
  @if (menu.subMenuItems?.length > 0) {
    <mat-expansion-panel>
      <mat-expansion-panel-header
        class="mobile-menu-item-content"
        [attr.accesskey]="menu.accessKey || null"
        [attr.aria-keyshortcuts]="menu.accessKey ? 'Alt+' + menu.accessKey : null"
        >
        <mat-panel-title>
          <div class="submenu-name">
            <div>{{menu.name}}</div>@if (menu.count !== undefined) {
            <div class="numberCircle">{{menu.count}}</div>
          }
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-accordion>
      <mat-action-list>
        @for (menu of menu.subMenuItems; track menu.id) {
          <ng-container *ngTemplateOutlet="menuTemplate; context: {$implicit: menu}"></ng-container>
        }
      </mat-action-list>
    </mat-accordion>
  </mat-expansion-panel>
} @else {
  <mat-list-item
    (click)="menuSelected(menu)"
    [attr.accesskey]="menu.accessKey || null"
    [attr.aria-keyshortcuts]="menu.accessKey ? 'Alt+' + menu.accessKey : null"
    >
    <div class="submenu-name">
      <div>{{menu.name}}</div>@if (menu.count !== undefined) {
      <div class="numberCircle">{{menu.count}}</div>
    }
  </div>
</mat-list-item>
}
</ng-template>